export const sortSchemaPropertiesByPriority = (properties: Record<string, any>) => Object.fromEntries(
  Object.entries(properties).sort(([, a], [, b]) => (a.priority || 99)-(b.priority || 99))
);

export const sortSchemaPropertiesArrayByPriority = (properties: any[]) => properties.sort((a, b) => (a.priority || 99)-(b.priority || 99));
